<template>
  <!-- if these tiles start getting too slow - remove tooltips and add an icon legend.  but, likely ok for now if projects don't exceed 200 -->
  <v-card
    tile
    flat
    v-if='project'
    class='my-0 py-0'
    @mouseover='hover = true'
    @mouseleave='hover = false'
  >
    <div class='wo-tile' :class="getClass.background">
      <div class='selected-bar' :class='project.is_selected ? "error" : getClass.background '></div>
      <div class='top-row'>
        <!-- top-row-items is an extra layer so that the whole top row area (other than the icons) can be used to select the tile -->
        <div class='top-row-items' @click='clicked'>
          <div class='wo-type'>
            <v-badge inline dot :color='getClass.badge'></v-badge>
            <span v-if='isSnowDivision' class='caption font-weight-bold ml-n1 mr-1' :class='getClass.main ? getClass.main : "primary--text"'>
              {{ project.project_detail.driveway_rating ? project.project_detail.driveway_rating_obj.rating.toFixed(1) : '??' }}
            </span>
          </div>
          <div class='name wo-name' :class='getClass.main' style='display:flex; align-items:center; gap:4px;'>
            {{ displayName }}
            <span v-if='isRockChip' title='Rock Chip Customer'
              style='display:inline-flex; align-items:center; vertical-align:middle; background:#F5F5F5; border-radius:4px; padding:2px; flex-shrink:0;'>
              <svg style='height:14px;width:14px;' viewBox="0 0 122.88 78.87" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M90.4,28.29l.08.24.22.62.08.24L91,30l.08.24.19.56.08.23.18.53.08.23.17.5.08.23L92,33l.07.23.15.44.08.23.14.4.08.23.13.38.08.22.12.35.07.22L93,36l.07.21.11.31.07.21.1.29.07.2.09.26.07.2.09.25.07.19.08.23.06.18.07.21.06.18.07.2.06.17.07.18,0,.17.06.16.06.16,0,.15,0,.16,0,.14.05.15,0,.12,0,.15,0,.11,0,.14,0,.1,0,.13,0,.1,0,.12,0,.09,0,.12,0,.08,0,.11,0,.07,0,.1,0,.07,0,.1,0,.06,0,.09v.06l0,.09,0,0,0,.08v0l0,.09,0,.11v.25h0l0,.18v.5h0V44h0v.08h0v.29h0v.35h0v.13h0v.13h0v.15h0v.16h0v.17h0v.18h0V46h0v.22h0v.24c.07,5,6.36,11,5.2,14.44s4.68,9.9,6.56,14.71H98.63a3.31,3.31,0,0,0-.6-1.91L79.93,44.76l3-4.85,3.65-3.66,3.69-8.1h0l.08.14ZM92.19,27l30.28,48.39a2.17,2.17,0,0,1,.41,1.28,2.21,2.21,0,0,1-2.21,2.21H3.28A3.28,3.28,0,0,1,.53,73.79L47.26,1.66A3.16,3.16,0,0,1,48.37.5,3.29,3.29,0,0,1,52.9,1.55L78.46,42.41l10-15.35a2.07,2.07,0,0,1,.75-.78,2.2,2.2,0,0,1,3,.71ZM52.44,75.58H3.9L14.33,61.79l16-28L39.47,23.2l4.65-10.28,6-9.64h0l.12.2c.88,2.66,1.26,4.11,2,6.25.44,1.23,2.3,3.91,2.67,4.93,5.31,14.76,2.62,9.34,2.69,15.88.08,7.51,9.47,16.45,7.74,21.53-1.93,5.62,8.38,16.22,10.31,23.51Z"/></svg>
            </span>
          </div>
        </div>
        <div class='icons'>
          <v-tooltip open-delay='100' top max-width='340'>
            <template v-slot:activator='{ on }'>
              <v-icon
                class='mr-1'
                v-on='on' small
                style='margin-right: -2px;'
                :color="!project.site_address && !project.site_city ? 'error' : !project.lng && !project.lat ? 'warning' : 'green'"
                @click='getLatLng'>
                mdi-map-marker-question
              </v-icon>
            </template>
            <span class='caption'>
            {{ project.site_address && project.site_city ?
            "No Geolocation Found (no pin created if group is mapped). Click to let Google set geolocation" :
            "No address or city - please fix on project page (auto-geolocation not possible)"}}</span>
          </v-tooltip>

          <v-tooltip open-delay='100' top>
            <template v-slot:activator='{ on }'>
              <v-icon v-on='on' v-if='isSnowDivision && project.project_detail.is_quickpay' small color="red">
                mdi-timer-outline
              </v-icon>
            </template>
            <span class='caption'>Quickpay Project</span>
          </v-tooltip>

          <v-icon v-if='getCrewVisitClass.icon' small class='mr-1' :color='getCrewVisitClass.color' @click='openCrewVisits'>{{ getCrewVisitClass.icon }}</v-icon>

          <v-tooltip open-delay='100' top>
            <template v-slot:activator='{ on }'>
              <v-icon v-on='on' v-if='getClass.icon' small :color="getClass.badge">
                {{ getClass.icon }}
              </v-icon>
            </template>
            <span class='caption'>{{ getClass.tooltip }}</span>
          </v-tooltip>

          <v-btn v-if='isLawnDivision || isSnowDivision' x-small icon @click='openQuickView' :class='getClass.main'>
            <v-icon :color="project.has_lawn_care && !project.frequency ? 'error' : '' " small>mdi-help-circle-outline</v-icon>
          </v-btn>

          <v-btn v-if='shouldShowInsertBox' x-small icon :disabled='isLoading' @click="$emit('insertBefore', project)">
            <v-icon color='error'>mdi-arrow-up-bold</v-icon>
          </v-btn>
        </div>
      </div>

      <div class='bottom-row' @click='clicked'>
        <div class='address wo-detail' :class='getClass.sub'>
          {{ project.site_address }},
        </div>
        <div class='city wo-detail' :class='getClass.sub'>
          {{ project.site_city }}
        </div>
        <div class='route wo-detail' :class='getClass.sub'>
          {{project.route_number }}
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'project-tile',
  props: {
    project: {
      required: true
    },
    hideInsertArrows: {
      required: false,
      type: Boolean,
      default: false
    },
    areProjectsSelected: {
      required: true      
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    hover: false,
    completedColor: 'grey lighten-2 ',
    attemptedColor: 'orange lighten-4 '
  }),
  computed: {
    getClass() {
      if (!this.project.route_group || !this.project.route_number) {
        return { 
          background: "red lighten-5",
          badge: this.isLawnDivision && this.project.has_lawn_care ? "success" : this.isSnowDivision ? "info" : "primary",
          icon: '',
          tooltip: '',
          main: '',
          sub: '',
        }
      } else if (this.project.on_hold) {
        return {
          background: 'white',
          badge: this.$icons.hold.color,
          icon: this.$icons.hold.icon,
          tooltip: 'This project is on hold.',
          main: 'error--text',
          sub: 'error--text',
        }
      } else if (this.project.status === 'Omit') {
        return {
          background: 'deep-purple lighten-4',
          badge: "purple",
          icon: 'mdi-calendar-minus',
          tooltip: 'Project is on a non-weekly schedule and is omitted this week.',
          main: '',
          sub: '',
        }
      } else if (this.project.status === 'Inactive') {
        return {
          background: 'grey lighten-4',
          badge: 'grey lighten-1',
          icon: 'mdi-calendar-remove-outline',
          tooltip: this.isLawnDivision ? 'No regular lawn care - not on fieldcrew mowing schedule' : 'Project is inactive and will not appear on the fieldcrew route',
          main: 'grey--text text--lighten-1',
          sub: 'grey--text text--lighten-1',
        }
      } else if (this.project.status === 'Unstarted') {
        return {
          background: 'grey lighten-2',
          badge: 'grey darken-2',
          icon: 'mdi-calendar-start',
          tooltip: "Project hasn't started yet - start date: " + this.$options.filters.shortDate(this.project.start_date),
          main: '',
          sub: '',
        }
      } else if (this.project.status === 'Ended') {
        return {
          background: 'grey lighten-2',
          badge: 'grey darken-2',
          icon: 'mdi-calendar-end',
          tooltip: "Project has ended - end date: " + this.$options.filters.shortDate(this.project.end_date),
          main: '',
          sub: '',
        }
      } 
      return {
        background: this.getCrewVisitClass.background,
        badge: this.isLawnDivision && this.project.has_lawn_care ? "success" : this.isSnowDivision ? "info" : "primary",
        icon: '',
        tooltip: '',
        main: '',
        sub: '',
      }
    },
    getCrewVisitClass () {
      if (this.project.crew_visit_status === "Attempted") {
        return { background: "orange lighten-4", icon: this.$icons.crewVisits.icon, color: "orange" }
      } else if (this.project.crew_visit_status === "Completed") {
        return { background: "green lighten-4", icon: this.$icons.crewVisits.icon, color: "green" }
      } else {
        return { background: "white", icon: '', color: '' }
      }
    },
    shouldShowInsertBox () {
      return this.hover && this.areProjectsSelected && !this.project.is_selected && this.project.route_number
    },
    isLawnDivision () {
      let lawnDiv = _.find(this.$store.state.misc.divisions, d => d.division === 'Lawn')
      return this.$route.params.id == lawnDiv.id
    },
    isSnowDivision () {
      let snowDiv = _.find(this.$store.state.misc.divisions, d => d.division === 'Snow')
      return this.$route.params.id == snowDiv.id
    },
    isRockChip () {
      return (this.project.project_detail && this.project.project_detail.ice_melt_ok) ||
        /\(rock\s*chip\)/i.test(this.project.name)
    },
    displayName () {
      return this.project.name.replace(/\s*\(rock\s*chip\)/gi, '').trim()
    }
  },
  methods: {
    clicked () {
      this.$emit('clicked', this.project)
    },
    openCrewVisits () {
      this.$emit('openCrewVisits', this.project)
    },
    openQuickView () {
      console.log(JSON.parse(JSON.stringify(this.project)))
      this.$emit('openQuickView', this.project)
    },
    getLatLng () {
      if (this.project.site_address && this.project.site_city) {
        this.$emit('getLatLng', this.project)
      }
    }
  }
}
</script>

<style scoped>

.wo-tile {
  display: grid;
  grid-template-columns: 5px 1fr;
  grid-template-rows: 19px 13px;
  cursor: pointer;
}

.selected-bar {
    grid-row: 1 / span 2;
}

.top-row {
    grid-column: 2 / -1;
    display: flex;
    overflow: hidden;
}

.bottom-row {
    grid-column: 2 / -1;
    display: flex;
    align-items: flex-end;
    overflow: hidden;
}

.top-row-items {
/* top row items includes the wotype badge and name but extends all the way to the first icon */
/* so it included the names' auto right margin which would otherwise be unclickable */
    display: flex;
    align-items: center;
    margin-right: auto;
    overflow: hidden;
    flex: 1;

}

.icons {
    display: flex;
    align-items: center;
}

.wo-type {
  margin-bottom: 1px;
  white-space: nowrap;
}

.icon {
  margin-left: 1px;
}

.city {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
    min-width: 25px;
    margin-right: auto;
    margin-left: 5px;
    flex-shrink: 100000;
    /* the large value here ensures the city field shrinks first before address gains ellipsis */
}

.name {
    margin-left: 1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.address {
    margin-left: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.route {
  white-space: nowrap;
  margin-left: 5px;
  margin-right: 3px;
}

.wo-name {
  font-size: 12px;
  font-weight: 700;
}

.wo-detail {
  font-size: 11px;
  color: grey;
}

.timeline {
  font-size: 10px;
  font-weight: 700;
}

.stripes {
  background: repeating-linear-gradient(
    90deg,
    #E1E1E1,
    #E1E1E1 10px,
    #EEEEEE 10px,
    #EEEEEE 20px
  );
}

</style>